import ImageWrapper from "../ImageComponent/ImageWrapper";

const LeftImageBox = ({ imageUrl, altText, onClick }) => {
  return (
    <div className=" md:w-[450px] md:h-[250px] lg:w-536 lg:h-296 overflow-hidden rounded-xl shadow-md bg-white hover:shadow-xl transition-shadow duration-300 ease-in-out relative">
      <div className="w-full h-38 xs:h-48 sm:h-60 md:w-[450px] md:h-[256px] lg:w-536 lg:h-296 overflow-hidden rounded-xl shadow-md bg-white hover:shadow-xl transition-shadow duration-300 ease-in-out">
        <ImageWrapper
          src={imageUrl}
          alt={altText}
          className="h-full rounded-xl object-cover"
          // priority="eager"
          onClick={onClick}
        />
      </div>
    </div>
  );
};

export default LeftImageBox;
